import type {
    InteractionType,
    PublicClientApplication,
} from '@azure/msal-browser';
import type { App } from 'vue';
import { RouterNavigationClient } from './router/RouterNavigationClient';
import { useMsalStore } from './stores/msal-store';
import type { Router } from 'vue-router';

export interface MsalPluginOptions {
    msalInstance: PublicClientApplication;
    router?: Router;
    defaultInteractionType?: InteractionType.Popup | InteractionType.Redirect;
}

export const msalPlugin = {
    install(app: App, options: MsalPluginOptions) {
        // Get the msal instance.
        const msalInstance = options.msalInstance;

        // Initialize the store.
        const store = useMsalStore();
        store.setMsalInstance(msalInstance);

        if (options.defaultInteractionType) {
            store.setDefaultInteractionType(options.defaultInteractionType);
        }

        // Set the navigation client to the router instance if it exists.
        const router = options.router;
        if (router) {
            const client = new RouterNavigationClient(router);
            msalInstance.setNavigationClient(client);
        }
    },
};
